<template>
  <div class="select-cate-dialog-container">
    <el-dialog title="选择商品类目" :visible="showSelectCate" width="620px" @close="btnCancel">
      <template>
        <div class="cate-box">
          <div class="cate-list">
            <div class="cate-title-box">
              <h4>一级分类</h4>
            </div>
            <el-input class="filter-input" size="mini" placeholder="输入关键字" v-model="firstFilterText"> </el-input>
            <div class="cate-tree">
              <el-tree
                highlight-current
                :data="firstCateData"
                :props="defaultProps"
                :filter-node-method="firstFilterNode"
                @node-click="firstHandleClick"
                ref="firstTree"
              >
              </el-tree>
            </div>
          </div>
          <i class="el-icon-arrow-right"></i>
          <div class="cate-list">
            <div class="cate-title-box">
              <h4>二级分类</h4>
            </div>
            <el-input class="filter-input" size="mini" placeholder="输入关键字" v-model="secondFilterText"> </el-input>
            <div class="cate-tree">
              <el-tree
                highlight-current
                :data="secondCateData"
                :props="defaultProps"
                :filter-node-method="secondFilterNode"
                @node-click="secondHandleClick"
                ref="secondTree"
              >
              </el-tree>
            </div>
          </div>
          <i class="el-icon-arrow-right"></i>
          <div class="cate-list">
            <div class="cate-title-box">
              <h4>三级分类</h4>
            </div>
            <el-input class="filter-input" size="mini" placeholder="输入关键字" v-model="thirdFilterText"> </el-input>
            <div class="cate-tree">
              <el-tree
                highlight-current
                :data="thirdCateData"
                :props="defaultProps"
                :filter-node-method="thirdFilterNode"
                @node-click="thirdHandleClick"
                ref="thirdTree"
              >
              </el-tree>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <el-row type="flex" justify="space-between">
          <el-col :span="18">
            <span>已选类目：</span>

            <span v-if="selectCate">{{ selectCate.classificationFullName || selectCate.text }}</span>
          </el-col>
          <el-col :span="6">
            <el-button size="mini" @click="btnCancel">取 消</el-button>
            <el-button size="mini" type="primary" @click="btnOK">确 定</el-button>
          </el-col>
        </el-row>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsCategoryFirstLevel, getGoodsSubCategory } from "@/api/publishGoods/publishGoods";

export default {
  props: {
    showSelectCate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectCate: null,
      firstFilterText: "",
      firstCateData: [],
      secondFilterText: "",
      secondCateData: [],
      thirdFilterText: "",
      thirdCateData: [],
      defaultProps: {
        label: "text",
        children: "",
      },
    };
  },
  created() {
    this.loadFirstCate();
  },
  watch: {
    firstFilterText(val) {
      this.$refs.firstTree.filter(val);
    },
    secondFilterText(val) {
      this.$refs.secondTree.filter(val);
    },
    thirdFilterText(val) {
      this.$refs.thirdTree.filter(val);
    },
  },
  methods: {
    async loadFirstCate() {
      const result = await getGoodsCategoryFirstLevel();
      this.firstCateData = result.data;
    },
    async firstHandleClick(data) {
      this.selectCate = data;
      this.secondCateData = [];
      this.thirdCateData = [];
      const result = await getGoodsSubCategory(data.id);
      this.secondCateData = result.data;
    },
    async secondHandleClick(data) {
      data.classificationFullName = data.classificationFullName.replace(/\//g, ">");
      this.selectCate = data;
      this.thirdCateData = [];
      const result = await getGoodsSubCategory(data.id);
      this.thirdCateData = result.data;
    },
    thirdHandleClick(data) {
      data.classificationFullName = data.classificationFullName.replace(/\//g, ">");
      this.selectCate = data;
    },
    firstFilterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    secondFilterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    thirdFilterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    btnOK() {
      if (!this.selectCate) {
        this.$message.error("请选择一级分类!");
        return;
      }
      if (this.selectCate.rank !== "3") {
        this.$message.error("请选择完整分类!");
        return;
      }
      this.$store.dispatch("publishGoods/publishGoods/setCateModel", this.selectCate);
      this.$emit("update:showSelectCate", false);
    },
    btnCancel() {
      this.$emit("update:showSelectCate", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-cate-dialog-container {
  .cate-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cate-list {
      display: flex;
      flex-direction: column;
      width: 170px;
      height: 250px;
      border: 1px solid lightgray;
      .cate-title-box {
        height: 25px;
        border-bottom: 1px solid lightgray;
      }
      .filter-input {
        margin: 5px;
        width: 90%;
      }
      .cate-tree {
        flex: 1;
        overflow: auto;
      }
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: start;
  }
}
</style>
